import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner, styled } from '@streem/ui-react';
export function EndingCallScreen() {
    return (_jsx(Container, { children: _jsx(Spinner, { size: "40px", color: "white" }) }));
}
const Container = styled.span `
    z-index: 3;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
//# sourceMappingURL=ending_call_screen.js.map